import {
  NOTES_GET,
  NOTE_ADD,
  NOTE_GET,
  NOTE_EDIT,
  NOTE_UPLOADFILE,
  NOTE_DELETE,
  NOTE_RESET_SEARCH,
} from './reduxConstant';

export const notesGet = (notes) => {
  return {
    type: NOTES_GET,
    payload: {
      notes,
    },
  };
};

export const noteAdd = (note) => {
  return {
    type: NOTE_ADD,
    payload: {
      note,
    },
  };
};

export const noteGet = (note) => {
  return {
    type: NOTE_GET,
    payload: {
      note,
    },
  };
};

export const noteEdit = (note) => {
  return {
    type: NOTE_EDIT,
    payload: {
      note,
    },
  };
};

export const noteUploadFile = (status) => {
  return {
    type: NOTE_UPLOADFILE,
    payload: {
      status,
    },
  };
};

export const noteDelete = (note) => {
  return {
    type: NOTE_DELETE,
    payload: {
      note,
    },
  };
};

export const noteResetSearch = () => {
  return {
    type: NOTE_RESET_SEARCH,
    payload: {},
  };
};
